import React, { useState } from "react";
import { Link } from "react-router-dom";
import { UserAuth } from "../context/AuthContext";
import { useTranslation } from "../hooks/useTranslation";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const { resetPassword } = UserAuth();
  const { t } = useTranslation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");
    try {
      await resetPassword(email);
      setMessage(t("checkInbox"));
    } catch (error) {
      setError(error.message);
    }
  };

  return (
    <div className="w-full h-screen">
      <video
        className="hidden sm:block absolute w-full h-full object-cover"
        autoPlay
        muted
        loop
        loading="lazy"
      >
        <source src="./www.grownasspizzaparty.com.webm" type="video/webm" />
        <source src="./www.grownasspizzaparty.com.mp4" type="video/mp4" />
        <img
          src="./background.jpg"
          alt="Ringette Live Banner"
          className="hidden sm:block absolute w-full h-full object-cover"
        />
      </video>
      <div className="bg-black/60 fixed top-0 left-0 w-full h-screen"></div>
      <div className="fixed w-full px-4 py-24 z-50">
        <div className="max-w-[450px] h-[600px] mx-auto bg-black/85 text-white">
          <div className="max-w-[320px] mx-auto py-16">
            <h1 className="text-3xl font-bold">{t("resetPassword")}</h1>
            {error && <p className="p-2 mt-1 bg-red-500">{error}</p>}
            {message && <p className="p-2 mt-1 bg-green-500">{message}</p>}
            <form onSubmit={handleSubmit} className="w-full flex flex-col py-4">
              <input
                onChange={(e) => setEmail(e.target.value)}
                className="p-3 my-2 bg-gray-700 rounded"
                type="email"
                placeholder={t("email")}
                autoComplete="email"
              />
              <button className="bg-green-800 py-3 my-6 rounded font-bold">
                {t("sendResetEmail")}
              </button>
              <p className="py-8">
                <span className="text-gray-600">
                  {t("rememberedPasswordQuestion")}
                </span>{" "}
                <Link to="/login">{t("signIn")}</Link>
              </p>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
